<template>
  <v-card>
    <v-card-text>
      <v-layout>
        <v-flex
          xs12
          sm6
        >
          <h2>{{ $t('message.user_details') }}</h2>
          <dl class="xs6">
            <dt>{{ $t('message.name') }}</dt>
            <dd>{{ user | fullName }}</dd>
            <dt>{{ $t('message.sex') }}</dt>
            <dd>{{ user.sex }}</dd>
            <dt>{{ $t('message.phone') }}</dt>
            <dd>{{ user.phone }}</dd>
            <dt>{{ $t('message.email') }}</dt>
            <dd>{{ user.email }}</dd>
            <dt>{{ $t('message.user_role') }}</dt>
            <dd>{{ $t('message.user_role_' + user.role) }}</dd>
            <dt>{{ $t('message.user_subscription') }}</dt>
            <dd>{{ $t('message.user_subscription_' + user.subscription) }}</dd>
            <dt>{{ $t('message.is_user_active') }}</dt>
            <dd>
              <v-icon
                v-if="user.active"
                color="success"
              >
                fa-check
              </v-icon>
              <v-icon
                v-else
                color="error"
              >
                fa-ban
              </v-icon>
            </dd>
            <dt>{{ $t('message.newsletter') }}</dt>
            <dd>
              {{
                user.receive_newsletter ? $t('message.yes') : $t('message.no')
              }}
            </dd>
            <dt>{{ $t('message.created') }}</dt>
            <dd>{{ user.createdAt | formatDateTime }}</dd>
          </dl>
        </v-flex>
        <v-flex
          v-if="company"
          xs12
          sm6
        >
          <h2>{{ $t('message.company_details') }}</h2>
          <dl
            v-if="company"
            class="xs6"
          >
            <dt>{{ $t('message.name') }}</dt>
            <dd>{{ company.name }}</dd>
            <dt>{{ $t('message.ubn_number') }}</dt>
            <dd>{{ company.ubnNumber }}</dd>
            <dt>{{ $t('message.tank_number') }}</dt>
            <dd>{{ company.tankNumber }}</dd>
            <dt>{{ $t('message.address') }}</dt>
            <dd class="no-wrap">
              {{ company.street }} {{ company.houseNumber
              }}{{ company.houseSuffix }}
            </dd>
            <dt class="no-wrap">
              {{ $t('message.postcode') }}
            </dt>
            <dd class="no-wrap">
              {{ company.postcode }}
            </dd>
            <dt class="no-wrap">
              {{ $t('message.city') }}
            </dt>
            <dd class="no-wrap">
              {{ company.city }}
            </dd>
            <dt>{{ $t('message.state') }}</dt>
            <dd>{{ company.state }}</dd>
            <dt>{{ $t('message.country') }}</dt>
            <dd>{{ company.countryCode }}</dd>
            <dt>{{ $t('message.email') }}</dt>
            <dd>{{ company.email }}</dd>
            <dt>{{ $t('message.phone') }}</dt>
            <dd>{{ company.phone }}</dd>
            <dt>{{ $t('message.coc_number') }}</dt>
            <dd>{{ company.cocNumber }}</dd>
            <dt>{{ $t('message.vat_number') }}</dt>
            <dd>{{ company.vatNumber }}</dd>
            <dt>{{ $t('message.created') }}</dt>
            <dd>{{ company.createdAt | formatDateTime }}</dd>
          </dl>
        </v-flex>
      </v-layout>
      <v-btn
        v-if="editable"
        dark
        color="secondary"
        @click="$emit('editUser', user)"
      >
        {{ $t('message.edit_user') }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import isEmpty from 'lodash/isEmpty'

export default {
  name: 'UserInfo',
  components: {},
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    company() {
      return this.user.companyTankNumber
        ? this.$store.state.companies[this.user.companyTankNumber]
        : undefined
    },
  },
  created() {
    if (!isEmpty(this.user.companyTankNumber)) {
      this.$store.dispatch('getCompany', {
        query: { tankNumber: this.user.companyTankNumber },
      })
    }
  },
}
</script>
<style lang="less">
dl {
  display: flex;
  flex-flow: row wrap;

  dt {
    flex-basis: 30%;
    padding: 2px 4px;
    text-align: right;
    color: #333;
    font-weight: 700;
  }

  dd {
    flex-basis: 65%;
    flex-grow: 1;
    margin: 0;
    padding: 2px 4px;
  }
}
</style>
